import React, { useEffect, useState } from "react";
import { PRIORITY_COLORS } from "../../../liveIncidents/models/incidents";

const PRIORITY_LABELS = {
  HIGH: "High",
  MEDIUM: "Medium",
  LOW: "Low",
  UNDEFINED: "Unclassified",
};

const STATUS_LABELS = {
  REPORTED: "Reported",
  CONFIRMED: "Confirmed",
  SCHEDULED: "Scheduled",
  RESOLVED: "Resolved",
  REJECTED: "Rejected",
};

const Row = ({ label, children }) => (
  <div className="flex items-start justify-between gap-3 py-2">
    <span className="shrink-0 text-xs text-gray-500 dark:text-gray-400">{label}</span>
    <span className="text-right text-xs font-medium text-navy-700 dark:text-white">{children}</span>
  </div>
);

const IncidentDetailView = ({ incident, segmentLabel, onBack }) => {
  const [photoUnavailable, setPhotoUnavailable] = useState(false);

  useEffect(() => {
    if (!incident) return;
    setPhotoUnavailable(false);
  }, [incident]);

  if (!incident) return null;

  const priorityColor = PRIORITY_COLORS[incident.priority] ?? "#9ca3af";

  return (
    <>
      <div className="shrink-0 border-b border-gray-200 px-4 pb-3 pt-3 dark:border-white/10">
        <button
          onClick={onBack}
          className="mb-1 flex items-center gap-1 text-xs text-gray-400 transition-colors hover:text-brand-500 dark:hover:text-brand-400"
          aria-label="Back to segment detail"
        >
          <span aria-hidden="true">‹</span>
          <span>{segmentLabel}</span>
        </button>
        <p className="font-mono text-sm font-semibold text-navy-700 dark:text-white">
          {incident.id}
        </p>
        <p className="text-xs text-gray-400">{incident.timestamp}</p>
      </div>

      <div className="flex-1 overflow-y-auto px-4 py-3">
        <div className="mb-4 overflow-hidden rounded-lg bg-gray-100 dark:bg-navy-700" style={{ height: 140 }}>
          {incident.photoUrl && !photoUnavailable ? (
            <img
              src={incident.photoUrl}
              alt="Incident"
              className="h-full w-full object-cover"
              onError={() => setPhotoUnavailable(true)}
            />
          ) : (
            <div className="flex h-full items-center justify-center">
              <span className="text-xs text-gray-400 dark:text-gray-500">No photo available</span>
            </div>
          )}
        </div>
        <div className="divide-y divide-gray-100 dark:divide-white/10">
          <Row label="Priority">
            <span className="flex items-center gap-1.5">
              <span
                className="h-2 w-2 rounded-full"
                style={{ backgroundColor: priorityColor }}
              />
              {PRIORITY_LABELS[incident.priority] ?? incident.priority}
            </span>
          </Row>
          <Row label="Status">
            {STATUS_LABELS[incident.status] ?? incident.status}
          </Row>
          <Row label="Reporter">
            <span className="capitalize">{incident.reporter}</span>
          </Row>
          {incident.description ? (
            <Row label="Details">{incident.description}</Row>
          ) : null}
          <Row label="Coordinates">
            {incident.latitude.toFixed(5)}, {incident.longitude.toFixed(5)}
          </Row>
          {incident.segmentId ? (
            <Row label="Segment">{incident.segmentId}</Row>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default IncidentDetailView;
